import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const RefreshStripeConnectStatusMutation = graphql.persisted(
  "RefreshStripeConnectStatus",
  graphql(`
    mutation RefreshStripeConnectStatus($input: RefreshStripeConnectStatusInput!) {
      refreshStripeConnectStatus(input: $input) {
        stripeAccount {
          id
          status
          connected
          active
          chargesEnabled
          payoutsEnabled
          onboardingComplete
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { RefreshStripeConnectStatusMutation };

export function useRefreshStripeConnectStatus() {
  return useMutation(RefreshStripeConnectStatusMutation);
}
